import type {
  ISyncSubscriptionRequestBody,
  ISyncSubscriptionResponseBody,
} from "~/feature/subscription/types";
import { api } from "~/store/api";

const API_PREFIX = "/subscription";

export const subscriptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    syncSubscription: builder.mutation<
      ISyncSubscriptionResponseBody,
      ISyncSubscriptionRequestBody
    >({
      query: (requestBody: ISyncSubscriptionRequestBody) => ({
        url: `${API_PREFIX}/sync`,
        method: "PUT",
        body: requestBody,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSyncSubscriptionMutation } = subscriptionApi;
